import Module from '../../../types/module';
import InputProcessor from "../../../types/input-processor";
import { AlmeUIInput } from '../../../types/input';

export default class ChannelRequestProcessor extends Module implements InputProcessor {
	constructor(settings) {
		super(settings);
	}

	process(input: AlmeUIInput): AlmeUIInput {
		const state = this._store?.getState() || {};
		const channel = state[this._settings.stateLocations.Conversation.Base][this._settings.stateLocations.Conversation.channel];

		if (!channel) {
			return Object.assign({}, input);
		} else {
			return Object.assign({}, input, { channel });
		}
	}
}



// WEBPACK FOOTER //
// ./node_modules/@alme/ui-web/modules/channel/src/request-processor-channel.ts